import React, {Component} from 'react';
import CSSModules from 'react-css-modules'
import config from '../../config'
import {Link, LinkIcon, GetStartedInput, AboutBanner} from '../../components'
import container from '../../helpers/container'

import Styles from './Macroclimate50.css'

@CSSModules(Styles)
export default class Macroclimate50 extends Component {
  constructor(props) {
    super(props)
    this.state = { }
  }

  componentWillMount() {
    if (typeof window !== 'undefined') {
      window.scrollTo(0,0)
    }
  }

  render() {
    const title = 'Macroclimate 50'
    const description = "Get your money out of fossil fuels. Use Fossil Free Funds to find out if you're invested in the largest coal-fired power plants."
    const url = config.domain + config.routes.macroclimate50

    const bannerImage = 'coal'
    const bannerHeadline = 'Macroclimate® 50'
    const bannerSubtitle = 'Public company owners of coal-fired power plants'
    const logoFirst = 'fff'
    const logoSecond = 'mc50'

    return (
      <div>
        {container.helmet(title, description, url)}

        <div styleName='image-banner-container'>
          <div styleName='image-banner-container-inner'>
            <div styleName={'image-banner-'+bannerImage}>
              <div styleName='image-banner-headline'>{bannerHeadline}</div>
              <div styleName='image-banner-subtitle'>{bannerSubtitle}</div>
            </div>
          </div>
        </div>

        <div styleName='page'>
          <div styleName='container'>
            <div styleName='container-inner'>
              <div styleName='title'>
                Find out if you're invested in 50 of the largest owners of coal-fired power plants
              </div>
              <p>Coal is among the largest sources of global warming pollution in the world. Obtaining it destroys mountains, burning it releases hazardous emissions, and disposing of it results in hazardous toxic waste. Coal is scorching the planet and leaving a legacy of devastation in its wake.</p>
              <p>That&rsquo;s why we partnered with <Link to={config.links.macroclimate} xstrong={true} title='Macroclimate'>Macroclimate<small><sup>&reg;</sup></small></Link> to screen mutual funds for the <Link to={config.links.mc50} xstrong={true} title='Macroclimate 50'>Macroclimate<small><sup>&reg;</sup></small> 50</Link> – an exclusion list of the 50 largest public-company owners of coal-fired power plants in Developed Markets plus China and India.</p>
              <p>Macroclimate<sup>&reg;</sup> compiled the list of 50 companies using open-source data on coal-fired power plants worldwide. These companies are emitting massive amounts of CO<sub>2</sub> and fueling climate change - and given coal’s volatility and unsustainable business model, it is becoming an increasingly risky investment.</p>
              <p>
                <Link
                  to={config.links.mc50}
                  xstrong={true}
                  title='Macroclimate 50'>
                  Visit Macroclimate<small><sup>&reg;</sup></small> to learn more about the list<LinkIcon />
                </Link>
              </p>
              <div styleName='double-logo-wrap'>
                <div styleName='double-logo'>
                  <div styleName='logo-first-wrap'>
                    <Link
                      to={config.routes.about}
                      title='Fossil Free Funds, a project of As You Sow'>
                      <div
                        styleName={'logo-'+logoFirst}
                        title='Fossil Free Funds, a project of As You Sow'
                      />
                    </Link>
                  </div>
                  <div styleName='logo-second-wrap'>
                    <Link
                      to={config.links.macroclimate}
                      title='Macroclimate'
                      >
                      <div
                        styleName={'logo-'+logoSecond}
                        title='Macroclimate'
                      />
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <GetStartedInput />

          <div styleName='x-mc50experts-wrap'>
            <div styleName='x-mc50experts-container'>
              <div styleName='x-mc50experts-container-inner'>
                <div styleName='x-mc50experts-info-photo'>
                  <div
                    styleName='x-mc50experts-photo'
                    title='Climate experts: The #1 problem is coal power'
                  />
                  <div styleName='x-mc50experts-info'>
                    <div styleName='x-mc50experts-info-title'>
                      The #1 problem is coal power
                    </div>
                    <p>
                      <Link to={config.links.mc50experts} xstrong title='Vision Prize: Expert Panel Findings'>A majority of expert panelists (64%)</Link> in 2014 believed that retiring (or sequestering) coal-fired power plants would be the single most effective use of major investments to limit global warming and the vast majority (84%) expected that coal-fired power plants alone will contribute between 25% and 60% or more of gross carbon emissions to the atmosphere between then and 2020. This is due in large part to the proliferation of new coal plants in China and in India. China and India have increased from less than a third of The Macroclimate&reg; 50 companies to now making up one half of the list.</p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div styleName='x-methodology-wrap'>
            <div styleName='x-methodology-container'>
              <div styleName='x-methodology-container-inner'>
                <div styleName='x-methodology-info-photo'>
                  <div
                    styleName='x-methodology-photo'
                    title='Macroclimate 50 methodology'
                  />
                  <div styleName='x-methodology-info'>
                    <div styleName='x-methodology-info-title'>
                      Methodology
                    </div>
                    <p>
                      Macroclimate periodically compiles extracts from <Link to='https://globalenergymonitor.org/projects/global-coal-plant-tracker/' xstrong title='Global Coal Plant Tracker'>Global Coal Plant Tracker</Link>, associates owners of the largest operating plants (including planned and new construction) in the relevant geographic areas with their respective publicly-traded companies, excludes companies rapidly phasing out their coal fleet in alignment with the Paris Agreement, and then ranks the remaining companies by their total coal-fired energy capacity (MWe). <Link to={config.links.mc50} xstrong={true} title='Macroclimate 50 methodology'>See the full methodology<LinkIcon/></Link></p>
                  </div>
                </div>

                <AboutBanner/>

              </div>
            </div>
          </div>

        </div>

      </div>
    )
  }
}
